import { render } from "./InvitationDetailView.vue?vue&type=template&id=146022a1"
import script from "./InvitationDetailView.vue?vue&type=script&lang=js"
export * from "./InvitationDetailView.vue?vue&type=script&lang=js"

import "./InvitationDetailView.vue?vue&type=style&index=0&id=146022a1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__